/**
 * Action types for the PaymentBatchWorkflow data reducer.
 */
export enum PaymentBatchActionTypes {
  SET_SELECT_POSITIONS_DATA = "SET_SELECT_POSITIONS_DATA",
  SET_PAYMENT_DETAILS = "SET_PAYMENT_DETAILS",
  SET_SELECTED_POSITIONS = "SET_SELECTED_POSITIONS",
  SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE",
  SET_BATCH_DATA = "SET_BATCH_DATA",
  SET_BATCH_OF_ONE = "SET_BATCH_OF_ONE",
}
